import { aludraApi } from 'Api/axios'

const mdl22 = {
  searchTypeList: 'mdl22/products/productCustomList/searchTypeList',
  productCustomList: 'mdl22/products/productCustomList',
  addUpdate:
    'mdl22/products/productCustomList/addUpdateProductCustomListQuantity',
}

const mdl04 = {
  productCustomList: 'mdl04/productCustomList',
  searchProducts: 'mdl04/SearchProducts/AdminPortal',
}

const mdl26 = {
  downloadBatchTemplateFile: batchTemplateId =>
    `mdl26/batchtemplate/${batchTemplateId}/csv`,
  batchProcessFile: 'mdl26/batch/quick-list/from-blob-file',
}

const mdl12 = {
  uploadFile: 'mdl12/UploadFile',
}

export const searchQuickListSettingsService = payload => {
  return aludraApi.post(mdl22.searchTypeList, payload)
}

export const getQuickListSettingService = productCustomListId => {
  return aludraApi.get(mdl22.productCustomList, {
    params: { productCustomListId },
  })
}

export const saveQuickListSettingService = payload => {
  return aludraApi.post(mdl22.addUpdate, payload)
}

export const deleteQuickListSettingService = productCustomListId => {
  return aludraApi.delete(mdl04.productCustomList, {
    data: { ProductCustomListId: productCustomListId },
  })
}

export const searchAdminProductsService = payload => {
  return aludraApi.post(mdl04.searchProducts, payload)
}

export const downloadBatchTemplateFileService = batchTemplateId => {
  return aludraApi.get(mdl26.downloadBatchTemplateFile(batchTemplateId), {
    responseType: 'blob',
  })
}

export const uploadFileService = (payload, config = {}) => {
  return aludraApi.post(mdl12.uploadFile, payload, {
    ...config,
    headers: {
      ...config.headers,
      'Content-Type': 'multipart/form-data',
    },
  })
}

export const batchProcessFileService = payload => {
  return aludraApi.post(mdl26.batchProcessFile, payload)
}
